export default "__VITE_ASSET__hn0WTeIZ__"